module.exports = __webpack_public_path__ + "img/thumbnail_Hippopotamus_j_normal.c29c30e3.png";